import { render } from "./GoogleSignIn.vue?vue&type=template&id=b0c50c3e"
import script from "./GoogleSignIn.vue?vue&type=script&lang=js"
export * from "./GoogleSignIn.vue?vue&type=script&lang=js"

import "./GoogleSignIn.vue?vue&type=style&index=0&id=b0c50c3e&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__